import { useFlags } from 'src/feature-flags/FlagsHook';
import { useAppContainerContext } from '../AppContainerContext';
import { useSiesta } from '../SiestaProvider';
import { openConversationFromServer } from './openConversationFromServer';

export function useOpenConversation() {
  const { loadHistory, beginHistoryLoad, endHistoryLoad, resumeActiveTurn, appendFailedMarker } =
    useSiesta();
  const { conversationId, setConversationId, setSiestaMode } = useAppContainerContext();
  const { flagEnabledSiestaChats } = useFlags();

  return (id: string) =>
    openConversationFromServer(id, {
      currentConversationId: conversationId,
      flagEnabledSiestaChats,
      loadHistory,
      beginHistoryLoad,
      endHistoryLoad,
      resumeActiveTurn,
      appendFailedMarker,
      setConversationId,
      setSiestaMode,
    });
}
